import { all } from 'redux-saga/effects'

import agenciesAPI from './agenciesSaga'
import authAPI from './authSaga'
import caseworkAPI from './caseworkSaga'
import constituentAPI from './constituentsSaga'
import contactMethodsAPI from './contactMethodsSaga'
import directoryAPI from './directorySaga'
import errorAPI from './errorSaga'
import groupsAPI from './groupsSaga'
import homeAPI from './homeSaga'
import profileAPI from './profileSaga'
import reportsAPI from './reportSaga'
import staffAPI from './staffSaga'
import toolsAPI from './toolsSaga'
import topicsAPI from './topicsSaga'

export default function* rootSaga() {
  yield all([
    authAPI(),
    caseworkAPI(),
    constituentAPI(),
    groupsAPI(),
    staffAPI(),
    directoryAPI(),
    profileAPI(),
    toolsAPI(),
    topicsAPI(),
    contactMethodsAPI(),
    homeAPI(),
    agenciesAPI(),
    reportsAPI(),
    errorAPI(),
  ])
}
